import { useSelector } from "react-redux";

const useTranslation = () => {
  const lang = useSelector((state) => state.system.currentLangCode);
  const { translations } = useSelector((state) => state.system);

  const findTranslation = (key) => {
    if (!translations || typeof translations !== "object") {
      return key;
    }

    const translation = Object.values(translations).find((t) => t.key === key);

    if (!translation || !translation.value) {
      return key;
    }

    return translation.value[lang] || key;
  };

  const tr = (key) => findTranslation(key);

  return { tr };
};

export default useTranslation;
